import { carouselItems } from '@/mocks/homepage';

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-8 md:mb-10">
          <i className="ri-focus-2-line text-xl text-primary-500"></i>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
            专题聚焦
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] md:aspect-[16/8] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 bg-primary-100 text-primary-700 text-[10px] font-semibold rounded-md mb-3">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}